import { render, staticRenderFns } from "./custom-textarea.vue?vue&type=template&id=9fc2c376&scoped=true"
import script from "./custom-textarea.vue?vue&type=script&lang=js"
export * from "./custom-textarea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fc2c376",
  null
  
)

export default component.exports